// removed by extract-text-webpack-plugin
module.exports = {"searchIcon":"search-module__searchIcon___1HwZo","bold":"search-module__bold___QuL4a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/search/search.module.scss
// module id = 1250
// module chunks = 0